import { createContext } from 'react';

import type { PaypalState } from '#src/app/shared/utils/payments';

export type { PaypalState } from '#src/app/shared/utils/payments';

export const PaypalContext = createContext<PaypalState>({ status: 'loading' });
